export const environment = {
  production: true,
  baseUrl: 'https://localpub.solocal.com',
  apiUrl: 'https://localpub-api.solocal.com',
  bridgeRedirect:'https://v3-portal.leadformance.com/',
  publicPage:'https://reporting-localpub.solocal.com',
  globalPublic:'https://bo.theramp.co/global-public-',
  RampUrl:"https://bo.theramp.co/",
  projectServer:'3',
  googleApiKey : 'AIzaSyB_hGmvPsKPeJoVPA8qgIcaci5yGRHhcHo',
  RampData:"https://assets.rampdata.fr/"

};
